import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "gatsby";
import { _ } from "../utils/i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong, faMinus } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/pro-light-svg-icons";
import Separator from "./separator";
import { ShowMoreButton, StyledIcon } from "./product-brands-filter";
import { useLocation } from "@reach/router";

const SideMenu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1.5rem;
  margin-inline: 1rem;
  padding: 1rem;
  background-color: var(--color-body);
`;

const ModalCategoryFilterHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  @media (min-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    display: none;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  @media (hover: hover) {
    &:hover {
      text-decoration: underline;
    }
  }
`;

const SideMenuItem = styled.div`
  display: flex;
  justify-content: space-between;
  span:nth-child(2) {
    color: var(--color-primary);
    opacity: 0.5;
  }
`;

const CategoryListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

const ProductCategoryFilter = ({
  category,
  categoryTitle,
  productCategoryPage,
  isModal,
  allCategories,
  searchMode = false,
}) => {
  const [isOpen, setOpen] = useState(true);
  const { search } = useLocation();
  const [showAllCategories, setShowAllCategories] = useState(false);

  const filteredCategories = allCategories.filter(
    (cat) => cat.wpParent === null
  );

  const displayedCategories =
    showAllCategories || searchMode
      ? allCategories
      : filteredCategories.slice(0, 8);

  let backLink;

  if (
    category?.wpParent?.node?.uri &&
    productCategoryPage !== category.wpParent.node.uri
  ) {
    backLink = category.wpParent.node.uri;

    if (searchMode) {
      backLink = `${category.wpParent.node.uri}${search}`;
    } else {
      backLink = category.wpParent.node.uri;
    }
  } else {
    if (searchMode) {
      backLink = `${productCategoryPage}søkeresultater/${search}`;
    } else {
      backLink = productCategoryPage;
    }
  }

  return (
    <SideMenu>
      {isModal && !(searchMode && !category) && (
        <Link to={backLink}>
          <FontAwesomeIcon
            icon={faArrowLeftLong}
            style={{ marginRight: "1rem" }}
          />
          {_("Tilbake")}
        </Link>
      )}

      <ModalCategoryFilterHeader>
        <h2 style={{ fontSize: "1.2rem" }}>
          {category ? category?.title : categoryTitle}
        </h2>
        <FontAwesomeIcon
          style={{ width: "1.5rem" }}
          icon={faMinus}
          onClick={() => setOpen((prev) => !prev)}
        />
      </ModalCategoryFilterHeader>

      {category?.wpChildren?.nodes?.length > 0 && isOpen && !searchMode && (
        <CategoryListWrapper>
          {category.wpChildren.nodes.map((childCat, i) => (
            <StyledLink key={i} to={childCat.uri}>
              <SideMenuItem>
                <span style={{ width: "70%" }}>{childCat.name}</span>
                <span>{`(${childCat?.products?.nodes?.length})`}</span>
              </SideMenuItem>
            </StyledLink>
          ))}
          <Separator isWide backgroundColor={"grey"} />
        </CategoryListWrapper>
      )}
      {(category?.uri === productCategoryPage || searchMode) && (
        <CategoryListWrapper>
          {displayedCategories.map((cat, i) => (
            <>
              {cat.products.nodes.length > 0 && (
                <StyledLink
                  key={i}
                  to={searchMode ? `${cat.uri}${search}` : cat.uri}
                >
                  <SideMenuItem>
                    <span style={{ width: "70%" }}>
                      {cat?.title ? cat.title : cat.name}
                    </span>
                    <span>{`(${cat?.products?.nodes?.length})`}</span>
                  </SideMenuItem>
                </StyledLink>
              )}
            </>
          ))}
          {!showAllCategories && filteredCategories.length > 8 && (
            <ShowMoreButton onClick={() => setShowAllCategories(true)}>
              {_("Vis mer")}
              <StyledIcon icon={faAngleDown} />
            </ShowMoreButton>
          )}
        </CategoryListWrapper>
      )}
    </SideMenu>
  );
};

ProductCategoryFilter.propTypes = {
  category: PropTypes.object,
  categoryTitle: PropTypes.string,
  searchMode: PropTypes.bool,
  allCategories: PropTypes.array,
  productCategoryPage: PropTypes.string,
  isModal: PropTypes.bool,
};

export default ProductCategoryFilter;
